<template>
  <div>
    <div style="padding:0 20px;">
			<ag-grid-vue
				:style="{ height: partType!='form'?'450px':'250px', fontSize: '14px' }"
				class="ag-theme-balham"
				headerHeight="40"
				rowHeight="42"
				:columnDefs="partType!='form'?columnDefs:columnDefs2"
				:gridReady="onGridReady"
				:defaultColDef="defaultColDef"
				:rowDragManaged="true"
				:animateRows="true"
				:rowData="rowData"
				suppressContextMenu=true
				:localeText="localeText"
				:rowDragEnd="onRowDragEnd">
			</ag-grid-vue>
    </div>
	<div class="diglog-bom-box mt-20" v-if="partType!='form'">
		<el-button type="primary" size="small" @click="dialogVisibleSave">{{Language('保存查询')}}</el-button>
		<el-button @click="dialogVisibleClose(false)" size="small">{{Language('取 消')}}</el-button>
	</div>
  </div>
</template>

<script>
	import {AgGridVue} from 'ag-grid-vue'
	import "ag-grid-enterprise"
	import { LicenseManager } from "ag-grid-enterprise"
	LicenseManager.setLicenseKey(
	"Zhongshan_Super_Yue_Power_Network_Technology_Co.,_Ltd._MultiApp_1Devs24_April_2019__MTU1NjA2MDQwMDAwMA==98fc2772019ab04e71440ab47643d10e"
	)
	import '@/views/Sass/Customfield/cod.css'
	import {
		getUserFormQueryList, getUserFormShowList, saveUserFormQueryData, saveUserFormShowData, getFormColumnList
	} from '@/http/Customfield.js'
export default {
	components: {
		'ag-grid-vue':AgGridVue,
		'checkBoxCompoent':{
			template: '<el-switch v-model="checked" @change="checkBoxChange" :disabled="params.data.fieldName==`title` || params.data.fieldName==`orderTypeCode` || params.data.fieldName==`formId`"></el-switch>',
			data(){
				return{
					checked: false,
					disabled: false,
				}
			},
			methods: {
				checkBoxChange(status) {
					let newStatus = status ?'1':'0'
					this.params.setValue(newStatus)
					this.params.data.isValid = newStatus
					this.params.api.refreshCells({ force: true })
				},
				init(){
					this.checked = this.params.value==1 ? true : false
				}
			},
			mounted(){
				this.init()
			}     
		}
	},
	props:{
		configType:{//表类型，1.客户 2.客户公司 3.工单
			type: Number, default: 1, required: true,
		},
		formValue:{//页面配置值 1.客户页面 2.公司页面 3.工单页面 4.未解决工单页面
			type: Number, default: 1, required: true,
		},
		visibleAllTitle:{ 
			type: Boolean, default: false, required: false,
		},
		partType: { //search: 搜索字段  column:列表显示字段 form:表单编辑字段
			type: String, default: false, required: false,
		},
		detData: { //工单表单显示字段
			type: Array, default: function() {
				return []
			}, required: false,
		}
	},
	watch:{
		visibleAllTitle: {
			deep: true,
			handler: function (newV, oldV) {
				if(newV){
					this.getData()
				}
			},
		},
		detData: {
			deep: true,
			handler: function (newV, oldV) {
				
			},
		},
	},
	data(){
		return{
			vdnId: JSON.parse(LocalStorage.getItem("obj")).vdnId,
			defaultColDef: {
				sortable: true,
				filter: true,
				menuTabs:[],//列工具
				lockPosition: true, //禁止拖动列的位置
			},
			localeText: {
				noRowsToShow: '暂无数据',
				loadingOoo: '数据加载中...'
			},
			gridApi: null,
			rowData: null,
			columnDefs: [
				{ field: 'cnName',headerName: "字段名称" },
				{ field: 'isValid',headerName: "是否显示", cellRendererFramework: 'checkBoxCompoent' },
				{ field: 'sort', headerName: "排序", rowDrag: true, width:80, cellClass: 'ag-text-center',
					cellRenderer: function (params) { return "" }                   
				},
			],
			columnDefs2: [
				{ field: 'fieldCnName',headerName: "字段名称" },
				{ field: 'isValid',headerName: "是否显示", cellRendererFramework: 'checkBoxCompoent' },
				{ field: 'sort', headerName: "排序", rowDrag: true, width:80, cellClass: 'ag-text-center',
					cellRenderer: function (params) { return "" }                   
				},
			],
		}
	},
	created() {
		
	},
	methods:{
		dialogVisibleClose(){
			this.$emit("closedialogVosible", false)
		},
		dialogVisibleSave(){
			let requestData = {}, queryData = []
			this.gridApi.forEachNode(node => {
				let sortNum = node.rowIndex+1
				let params = {
					fieldId: node.data.id,
					seq: sortNum.toString(),//排序
					isValid: node.data.isValid
				}
				queryData.push(params)
			})
			requestData = {
				vdnId: this.vdnId,
				formValue: this.formValue,
			}
			if (this.partType == 'search') {
				requestData['queryData'] = queryData
				saveUserFormQueryData(requestData).then(res => {
					if(res.retCode == 1){
						this.$Msg.success('修改成功');
						this.$emit("getNewData")
						this.$emit("closedialogVosible", false)
					}
				})
			} 
			if (this.partType == 'column') {
				requestData['showData'] = queryData
				saveUserFormShowData(requestData).then(res => {
					if(res.retCode == 1){
						this.$Msg.success('修改成功');
						this.$emit("getNewData")
						this.$emit("closedialogVosible", false)
					}
				})
			}
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			// 调整表格列宽大小自适应
			this.gridApi.sizeColumnsToFit()
			this.getData()
		},
		onRowDragEnd(e) {//拖动排序

		},
		//获取搜索字段
		fetchUserFormQueryListFn() {
			getUserFormQueryList({
				vdnId: this.vdnId,
				configType: this.configType,
				formValue: this.formValue,
				isValid: ''
			}).then(res => {
				if (res&&res.retCode==1) {
					this.gridApi.setRowData(res.data)
					if(this.gridApi){
						this.gridApi.sizeColumnsToFit()
					}
				}else{
					this.gridApi.setRowData([])
				}
			}).catch((error)=>{
				this.gridApi.setRowData([])
			})
		},
		//获取列表展示字段
		fetchUserFormShowListFn() {
			getUserFormShowList({
				vdnId: this.vdnId,
				configType: this.configType,
				formValue: this.formValue,
				isValid: ''
			}).then(res => {
				if (res&&res.retCode==1) {
					this.gridApi.setRowData(res.data)
					if(this.gridApi){
						this.gridApi.sizeColumnsToFit()
					}
				}else{
					this.gridApi.setRowData([])
				}
			}).catch((error)=>{
				this.gridApi.setRowData([])
			})
		},
		//获取表单编辑字段信息
		fetchFormColumnListFn() {
			const self = this
			getFormColumnList({
				vdnId: this.vdnId,
				configType: this.configType
			}).then(res => {
				if (res&&res.retCode==1) {
					let resData = res.data, newResData = [], isValidObj = [], notValidObj = []
					resData.map(item => {
						if (item.fieldName=='title' || item.fieldName=='orderTypeCode' || item.fieldName=='formId') item.isValid = 1
					})
					if (this.detData.length) {
						if (resData.length) {
							this.detData.map(item => {
								resData.map((item2, index) => {
									if (item.fieldId == item2.fieldId) {
										item2['isValid'] = 1
										item2['detId'] = item.detId
										isValidObj.push(item2)
									}
								})
							})
							resData.map((item, index) => {
								if (item.isValid != 1) notValidObj.push(item)
							})
							newResData = isValidObj.concat(notValidObj)
						} 
					} else {
						resData.map((item, index) => {
							if (item.isValid != 1) notValidObj.push(item)
							else isValidObj.push(item)
						})
						newResData = isValidObj.concat(notValidObj)
					}
					self.gridApi.setRowData(newResData)
					if(this.gridApi){
						this.gridApi.sizeColumnsToFit()
					}
				}else{
					this.gridApi.setRowData([])
				}
			}).catch((error)=>{
				this.gridApi.setRowData([])
			})
		},
		getData(){
			if (this.partType == 'search') this.fetchUserFormQueryListFn()
			else if (this.partType == 'column') this.fetchUserFormShowListFn()
			else this.fetchFormColumnListFn()
		},
	},
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// SearchSet.vue?3f44d271